import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Navbar from './components/Navbar';
import Troypus from './pages/public/troypus';
import Dashboard from './pages/admin/dashboard';
import Skill from './pages/admin/skill';
import Articles from './pages/admin/articles';
import Project from './pages/admin/project';
import Home from './pages/home';
import Kaipedia from './pages/public/kaipedia';
import Catcase from './pages/public/catcase';
import KaipediaDetail from './pages/public/kaipedia/detail';
import Chess from './pages/public/showcase/chess';
import Katz from './pages/public/showcase/katz';
import Dogcase from './pages/public/dogcase';
import Showcase from './pages/public/showcase';
import NotFound from './pages/NotFound';
import KaipediaLayout from "./layouts/KaipediaLayouts";

function App() {
  return (
    <div className="min-h-screen bg-gray-900">
      <Navbar />
      <Toaster
        position="top-center"
        containerStyle={{
          top: "80px",
        }}
        toastOptions={{
          duration: 5000,
          style: {
            background: '#1E40AF',
            color: '#fff',
            padding: '16px',
            borderRadius: '10px',
          },
          className: 'border border-blue-400/30',
        }}
      />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route element={<KaipediaLayout />}>
            <Route path="/kaipedia" element={<Kaipedia />} />
            <Route path="/kaipedia/:id" element={<KaipediaDetail />} />
          </Route>
          <Route path="/catcase" element={<Catcase />} />
          <Route path="/showcase/katz" element={<Katz />} />
          <Route path="/dogcase" element={<Dogcase />} />
          <Route path="/showcase" element={<Showcase />} />
          <Route path="/showcase/chess" element={<Chess />} />
          <Route path="/troypus" element={<Troypus />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/project" element={<Project />} />
          <Route path="/skill" element={<Skill />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
